'use strict';

var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-6a5a8a7f.js');
var React = require('react');
var AtoZDatepicker = require('@amzn/atoz-datepicker');
var context = require('@amzn/stencil-react-components/context');
var layout = require('@amzn/stencil-react-components/layout');
var text = require('@amzn/stencil-react-components/text');
var icons = require('@amzn/stencil-react-components/icons');
var button = require('@amzn/stencil-react-components/button');
var cx = require('classnames');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var AtoZDatepicker__default = /*#__PURE__*/_interopDefaultLegacy(AtoZDatepicker);
var cx__default = /*#__PURE__*/_interopDefaultLegacy(cx);

var _templateObject;
var DatepickerLegend = function DatepickerLegend(_ref) {
  var primaryKeyLegend = _ref.primaryKeyLegend,
      secondaryKeyLegend = _ref.secondaryKeyLegend,
      tertiaryKeyLegend = _ref.tertiaryKeyLegend,
      attentionKeyLegend = _ref.attentionKeyLegend,
      alertKeyLegend = _ref.alertKeyLegend,
      dotKeyLegend = _ref.dotKeyLegend,
      triangleKeyLegend = _ref.triangleKeyLegend;
  var renderLegend = primaryKeyLegend || secondaryKeyLegend || tertiaryKeyLegend || attentionKeyLegend || alertKeyLegend || dotKeyLegend || triangleKeyLegend;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, renderLegend && /*#__PURE__*/React__default["default"].createElement(layout.Row, {
    justifyContent: 'center',
    flexWrap: 'wrap',
    backgroundColor: 'neutral0',
    gridGap: 'S300',
    padding: {
      top: 'S300',
      bottom: 'S300'
    },
    "data-testid": 'DatepickerLegendContainer'
  }, primaryKeyLegend && /*#__PURE__*/React__default["default"].createElement(layout.Row, {
    alignItems: 'center',
    "data-testid": 'DatepickerLegendPrimary'
  }, /*#__PURE__*/React__default["default"].createElement(PrimaryKey, null), /*#__PURE__*/React__default["default"].createElement(text.Text, {
    fontSize: 'T200'
  }, primaryKeyLegend)), attentionKeyLegend && /*#__PURE__*/React__default["default"].createElement(layout.Row, {
    alignItems: 'center',
    "data-testid": 'DatepickerLegendAttention'
  }, /*#__PURE__*/React__default["default"].createElement(AttentionKey, null), /*#__PURE__*/React__default["default"].createElement(text.Text, {
    fontSize: 'T200'
  }, attentionKeyLegend)), alertKeyLegend && /*#__PURE__*/React__default["default"].createElement(layout.Row, {
    alignItems: 'center',
    "data-testid": 'DatepickerLegendAlert'
  }, /*#__PURE__*/React__default["default"].createElement(AlertKey, null), /*#__PURE__*/React__default["default"].createElement(text.Text, {
    fontSize: 'T200'
  }, alertKeyLegend)), secondaryKeyLegend && /*#__PURE__*/React__default["default"].createElement(layout.Row, {
    alignItems: 'center',
    "data-testid": 'DatepickerLegendSecondary'
  }, /*#__PURE__*/React__default["default"].createElement(SecondaryKey, null), /*#__PURE__*/React__default["default"].createElement(text.Text, {
    fontSize: 'T200'
  }, secondaryKeyLegend)), tertiaryKeyLegend && /*#__PURE__*/React__default["default"].createElement(layout.Row, {
    alignItems: 'center',
    "data-testid": 'DatepickerLegendTertiary'
  }, /*#__PURE__*/React__default["default"].createElement(TertiaryKey, null), /*#__PURE__*/React__default["default"].createElement(text.Text, {
    fontSize: 'T200'
  }, tertiaryKeyLegend)), triangleKeyLegend && /*#__PURE__*/React__default["default"].createElement(layout.Row, {
    alignItems: 'center',
    "data-testid": 'DatepickerLegendTriangle'
  }, /*#__PURE__*/React__default["default"].createElement(TriangleKey, null), /*#__PURE__*/React__default["default"].createElement(text.Text, {
    fontSize: 'T200'
  }, triangleKeyLegend)), dotKeyLegend && /*#__PURE__*/React__default["default"].createElement(layout.Row, {
    alignItems: 'center',
    "data-testid": 'DatepickerLegendDot'
  }, /*#__PURE__*/React__default["default"].createElement(DotKey, null), /*#__PURE__*/React__default["default"].createElement(text.Text, {
    fontSize: 'T200'
  }, dotKeyLegend))));
};
var CalKeySpan = context.styledWithTheme('span')(_templateObject || (_templateObject = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n    height: 13px;\n    width: 13px;\n    content: '';\n    display: inline-block;\n    margin-right: 5px;\n    vertical-align: middle;\n"])));
var PrimaryKey = context.styledWithTheme(CalKeySpan)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    backgroundColor: theme.selectors.color('primary70')
  };
});
var AttentionKey = context.styledWithTheme(CalKeySpan)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    background: "linear-gradient(-45deg, \n        ".concat(theme.selectors.color('neutral10'), " 25%, \n        ").concat(theme.selectors.color('red70'), " 25%, \n        ").concat(theme.selectors.color('red70'), " 75%, \n        ").concat(theme.selectors.color('neutral10'), " 75%)"),
    backgroundColor: theme.selectors.color('red70')
  };
});
var SecondaryKey = context.styledWithTheme(CalKeySpan)(function (_ref4) {
  var theme = _ref4.theme;
  return {
    background: "repeating-linear-gradient(-45deg, \n        ".concat(theme.selectors.color('primary20'), ", \n        ").concat(theme.selectors.color('primary20'), " 6px, \n        ").concat(theme.selectors.color('neutral0'), " 1px, \n        ").concat(theme.selectors.color('neutral0'), " 7px)")
  };
});
var TertiaryKey = context.styledWithTheme(CalKeySpan)(function (_ref5) {
  var theme = _ref5.theme;
  return " \n    background-color: ".concat(theme.selectors.color('neutral100'), ";\n    height: 5px;\n    width: 5px;\n    border-radius: 100%;\n");
});
var TriangleKey = context.styledWithTheme(CalKeySpan)(function (_ref6) {
  var theme = _ref6.theme;
  return {
    background: "linear-gradient(to bottom right, \n        ".concat(theme.selectors.color('primary70'), " 40%, transparent 40%, \n        ").concat(theme.selectors.color('neutral0'), " 7px)")
  };
});
var AlertKey = context.styledWithTheme(CalKeySpan)(function (_ref7) {
  var theme = _ref7.theme;
  return "background: linear-gradient(\n        -45deg, \n        transparent 0%, \n        transparent 25%, \n        ".concat(theme.selectors.color('neutral10'), " 25%, \n        ").concat(theme.selectors.color('red70'), " 25%, \n        ").concat(theme.selectors.color('red70'), " 75%, \n        ").concat(theme.selectors.color('neutral10'), " 75%, \n        transparent 75%,\n        transparent 100%);\n        ");
});
var DotKey = context.styledWithTheme(CalKeySpan)(function (_ref8) {
  var theme = _ref8.theme;
  return {
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: theme.selectors.color('neutral10')
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: '6px',
      left: '7px',
      width: '5px',
      height: '5px',
      background: theme.selectors.color('neutral100'),
      borderRadius: '50%'
    }
  };
});

var DatepickerHeader = function DatepickerHeader(_ref) {
  var date = _ref.date,
      decreaseMonth = _ref.decreaseMonth,
      increaseMonth = _ref.increaseMonth,
      prevMonthButtonDisabled = _ref.prevMonthButtonDisabled,
      nextMonthButtonDisabled = _ref.nextMonthButtonDisabled,
      locale = _ref.locale,
      previousMonthAriaLabel = _ref.previousMonthAriaLabel,
      nextMonthAriaLabel = _ref.nextMonthAriaLabel,
      headerTextProps = _ref.headerTextProps;
  var dateLocale = locale ? locale : 'default';
  return /*#__PURE__*/React__namespace.createElement(layout.Row, {
    alignItems: 'center',
    justifyContent: 'space-between',
    className: 'datepicker-custom-header'
  }, /*#__PURE__*/React__namespace.createElement(text.Text, _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, headerTextProps), {}, {
    dataTestId: 'DatepickerNavHeaderText'
  }), date.toLocaleString(dateLocale, {
    month: 'long',
    year: 'numeric'
  })), /*#__PURE__*/React__namespace.createElement(layout.Row, {
    gridGap: 'S300'
  }, /*#__PURE__*/React__namespace.createElement(button.Button, {
    "aria-label": previousMonthAriaLabel,
    onClick: decreaseMonth,
    disabled: prevMonthButtonDisabled,
    "data-testid": 'DatepickerNavPrev',
    icon: /*#__PURE__*/React__namespace.createElement(icons.IconChevronLeft, {
      color: prevMonthButtonDisabled ? 'neutral30' : 'primary70',
      size: icons.IconSize.Small
    }),
    variant: button.ButtonVariant.Tertiary
  }), /*#__PURE__*/React__namespace.createElement(button.Button, {
    "aria-label": nextMonthAriaLabel,
    onClick: increaseMonth,
    disabled: nextMonthButtonDisabled,
    "data-testid": 'DatepickerNavNext',
    icon: /*#__PURE__*/React__namespace.createElement(icons.IconChevronRight, {
      color: nextMonthButtonDisabled ? 'neutral30' : 'primary70',
      size: icons.IconSize.Small
    }),
    variant: button.ButtonVariant.Tertiary
  })));
};

var getDateId = function getDateId(date) {
  return "date-".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate());
};
var WEEK_ROW = 'weekRow';
var WEEK_ROW_HEADER = 'weekRowHeader';
var WEEK_ROW_DATEPICKER = 'weekRowDatepicker';
var ATOZ_DATEPICKER = 'AtoZDatepicker';
var WEEK_ROW_NAV_PREV = 'weekRowNavPrev';
var WEEK_ROW_NAV_NEXT = 'weekRowNavNext';
var WEEK_ROW_TITLE = 'weekRowTitle';

var _excluded = ["markers", "dataTestId", "previousMonthAriaLabel", "nextMonthAriaLabel", "headerTextProps", "locale", "overrideTodayDate", "setDisplayingMonth", "displayingMonth"];
var Datepicker = function Datepicker(_ref) {
  var markers = _ref.markers,
      dataTestId = _ref.dataTestId,
      previousMonthAriaLabel = _ref.previousMonthAriaLabel,
      nextMonthAriaLabel = _ref.nextMonthAriaLabel,
      headerTextProps = _ref.headerTextProps,
      locale = _ref.locale,
      overrideTodayDate = _ref.overrideTodayDate,
      setDisplayingMonth = _ref.setDisplayingMonth,
      displayingMonth = _ref.displayingMonth,
      rest = _rollupPluginBabelHelpers._objectWithoutProperties(_ref, _excluded);

  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;

  var normalizeKeyDates = function normalizeKeyDates(keyDates) {
    return new Set(keyDates === null || keyDates === void 0 ? void 0 : keyDates.map(function (date) {
      return date.toDateString();
    }));
  };

  var normalizedPrimaryKeyDates = React__default["default"].useMemo(function () {
    var _a;

    return normalizeKeyDates((_a = markers === null || markers === void 0 ? void 0 : markers.primary) === null || _a === void 0 ? void 0 : _a.dates);
  }, [(_a = markers === null || markers === void 0 ? void 0 : markers.primary) === null || _a === void 0 ? void 0 : _a.dates]);
  var normalizedSecondaryKeyDates = React__default["default"].useMemo(function () {
    var _a;

    return normalizeKeyDates((_a = markers === null || markers === void 0 ? void 0 : markers.secondary) === null || _a === void 0 ? void 0 : _a.dates);
  }, [(_b = markers === null || markers === void 0 ? void 0 : markers.secondary) === null || _b === void 0 ? void 0 : _b.dates]);
  var normalizedTertiaryKeyDates = React__default["default"].useMemo(function () {
    var _a;

    return normalizeKeyDates((_a = markers === null || markers === void 0 ? void 0 : markers.tertiary) === null || _a === void 0 ? void 0 : _a.dates);
  }, [(_c = markers === null || markers === void 0 ? void 0 : markers.tertiary) === null || _c === void 0 ? void 0 : _c.dates]);
  var normalizedAttentionKeyDates = React__default["default"].useMemo(function () {
    var _a;

    return normalizeKeyDates((_a = markers === null || markers === void 0 ? void 0 : markers.attention) === null || _a === void 0 ? void 0 : _a.dates);
  }, [(_d = markers === null || markers === void 0 ? void 0 : markers.attention) === null || _d === void 0 ? void 0 : _d.dates]);
  var normalizedDotKeyDates = React__default["default"].useMemo(function () {
    var _a;

    return normalizeKeyDates((_a = markers === null || markers === void 0 ? void 0 : markers.dot) === null || _a === void 0 ? void 0 : _a.dates);
  }, [(_e = markers === null || markers === void 0 ? void 0 : markers.dot) === null || _e === void 0 ? void 0 : _e.dates]);
  var normalizedTriangleKeyDates = React__default["default"].useMemo(function () {
    var _a;

    return normalizeKeyDates((_a = markers === null || markers === void 0 ? void 0 : markers.triangle) === null || _a === void 0 ? void 0 : _a.dates);
  }, [(_f = markers === null || markers === void 0 ? void 0 : markers.triangle) === null || _f === void 0 ? void 0 : _f.dates]);
  var normalizedAlertKeyDates = React__default["default"].useMemo(function () {
    var _a;

    return normalizeKeyDates((_a = markers === null || markers === void 0 ? void 0 : markers.alert) === null || _a === void 0 ? void 0 : _a.dates);
  }, [(_g = markers === null || markers === void 0 ? void 0 : markers.alert) === null || _g === void 0 ? void 0 : _g.dates]);
  var today = overrideTodayDate ? overrideTodayDate.toDateString() : new Date().toDateString();

  var mapDatesToClasses = function mapDatesToClasses(day) {
    var dateString = day.toDateString();
    return cx__default["default"]({
      'ui-state-attention': normalizedAttentionKeyDates === null || normalizedAttentionKeyDates === void 0 ? void 0 : normalizedAttentionKeyDates.has(dateString),
      'ui-state-primary': normalizedPrimaryKeyDates === null || normalizedPrimaryKeyDates === void 0 ? void 0 : normalizedPrimaryKeyDates.has(dateString),
      'ui-state-secondary': normalizedSecondaryKeyDates === null || normalizedSecondaryKeyDates === void 0 ? void 0 : normalizedSecondaryKeyDates.has(dateString),
      'ui-state-tertiary': normalizedTertiaryKeyDates === null || normalizedTertiaryKeyDates === void 0 ? void 0 : normalizedTertiaryKeyDates.has(dateString),
      'ui-state-today': today === dateString,
      'ui-state-dot': normalizedDotKeyDates === null || normalizedDotKeyDates === void 0 ? void 0 : normalizedDotKeyDates.has(dateString),
      'ui-state-triangle': normalizedTriangleKeyDates === null || normalizedTriangleKeyDates === void 0 ? void 0 : normalizedTriangleKeyDates.has(dateString),
      'ui-state-alert': normalizedAlertKeyDates === null || normalizedAlertKeyDates === void 0 ? void 0 : normalizedAlertKeyDates.has(dateString)
    });
  };

  var AtoZDatepickerWrapper = function AtoZDatepickerWrapper(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/React__default["default"].createElement(AtoZDatepickerStyledWrapper, {
      "data-testid": dataTestId,
      "data-inUseLocale": locale
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: 'react-datepicker'
    }, children));
  };

  return /*#__PURE__*/React__default["default"].createElement(DatepickerWrapper, {
    "data-testid": ATOZ_DATEPICKER
  }, /*#__PURE__*/React__default["default"].createElement(AtoZDatepicker__default["default"], _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({
    calendarContainer: AtoZDatepickerWrapper,
    dayClassName: mapDatesToClasses,
    renderDayContents: function renderDayContents(day, date) {
      return /*#__PURE__*/React__default["default"].createElement("div", {
        id: getDateId(date),
        className: 'day-content'
      }, day);
    },
    renderCustomHeader: function renderCustomHeader(headerProps) {
      if (setDisplayingMonth) {
        if (headerProps.date.getMonth() !== displayingMonth) {
          setDisplayingMonth(headerProps.date.getMonth());
        }
      }

      return /*#__PURE__*/React__default["default"].createElement(DatepickerHeader, _rollupPluginBabelHelpers._objectSpread2({
        previousMonthAriaLabel: previousMonthAriaLabel,
        nextMonthAriaLabel: nextMonthAriaLabel,
        headerTextProps: headerTextProps,
        locale: locale
      }, headerProps));
    },
    locale: locale
  }, rest), {}, {
    calendarStartDay: 0
  })), /*#__PURE__*/React__default["default"].createElement(DatepickerLegend, {
    primaryKeyLegend: (_h = markers === null || markers === void 0 ? void 0 : markers.primary) === null || _h === void 0 ? void 0 : _h.label,
    secondaryKeyLegend: (_j = markers === null || markers === void 0 ? void 0 : markers.secondary) === null || _j === void 0 ? void 0 : _j.label,
    tertiaryKeyLegend: (_k = markers === null || markers === void 0 ? void 0 : markers.tertiary) === null || _k === void 0 ? void 0 : _k.label,
    attentionKeyLegend: (_l = markers === null || markers === void 0 ? void 0 : markers.attention) === null || _l === void 0 ? void 0 : _l.label,
    alertKeyLegend: (_m = markers === null || markers === void 0 ? void 0 : markers.alert) === null || _m === void 0 ? void 0 : _m.label,
    dotKeyLegend: (_o = markers === null || markers === void 0 ? void 0 : markers.dot) === null || _o === void 0 ? void 0 : _o.label,
    triangleKeyLegend: (_p = markers === null || markers === void 0 ? void 0 : markers.triangle) === null || _p === void 0 ? void 0 : _p.label
  }));
};
var DatepickerWrapper = context.styledWithTheme('div')(function (_ref3) {
  var theme = _ref3.theme;
  return " \n    * {\n        font-family: ".concat(theme.selectors.fontFamily('primary'), " !important\n    }\n");
});
var AtoZDatepickerStyledWrapper = context.styledWithTheme('div')(function (_ref4) {
  var theme = _ref4.theme;
  return "\n    line-height: 0;\n\n    .react-datepicker {\n        background: transparent;\n        width: 100%;\n    }\n    \n    .react-datepicker__header {\n        background: transparent;\n        text-align: left;\n        padding-top: 0;\n\n        @media (max-width: ".concat(theme.selectors.breakpoint('s').max, "px) {\n            background: white;\n            padding-top: 9px;\n        }\n    }\n\n    .react-datepicker__nav {\n        align-items: center;\n        background: transparent;\n        border-radius: 0;\n        border: 2px solid transparent;\n        display: inline-flex;\n        height: 36px;\n        justify-content: center;\n        width: 36px;\n\n        &:focus {\n            border-color: ").concat(theme.selectors.color('primary70'), ";\n            outline: none !important;\n        }\n\n        &:first-child {\n            margin-right: 8px;\n        }\n    }\n\n    .react-datepicker__day:hover {\n        background-color: transparent;\n    }\n\n    .react-datepicker__day--keyboard-selected {\n        background-color: transparent;\n        color: inherit;\n    }\n\n    .using-keyboard {\n        .react-datepicker__day--keyboard-selected {\n            @media (min-width: ").concat(theme.selectors.breakpoint('s').max, "px) {\n                outline: ").concat(theme.selectors.color('yellow60'), " solid medium;\n                z-index: 3;\n                outline-offset: 1px;\n            }\n        }\n    }\n    .react-datepicker__month {\n        background: white;\n        border: none;\n        width: inherit;\n    }\n    .react-datepicker__month-container {\n        width: 100%;\n    }\n\n    .react-datepicker__day--selected {\n        background-color: ").concat(theme.selectors.color('neutral0'), ";\n        color: ").concat(theme.selectors.color('neutral100'), ";\n        font-weight: bold;\n        text-align: center;\n        outline: 4px solid ").concat(theme.selectors.color('yellow60'), ";\n        outline-offset: -4px;\n        box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5);\n        z-index: 2;\n        &.ui-state-tertiary {\n            position: relative;\n            &::after {\n                background: ").concat(theme.selectors.color('neutral100'), ";\n            }\n        }\n        &.ui-state-dot {\n            position: relative;\n            &::after {\n                background: ").concat(theme.selectors.color('neutral100'), ";\n            }\n        }\n    }\n    .react-datepicker__day {\n        width: calc((100vw - 32px) / 7);\n        height: calc((100vw - 32px) / 7);\n        line-height: calc((100vw - 32px) / 7);\n        position: relative;\n        text-align: center;\n        @media (min-width: ").concat(theme.selectors.breakpoint('s').max, "px) {\n            width: 47px;\n            height: 47px;\n            line-height: 47px;\n        }\n        border: 1px solid ").concat(theme.selectors.color('neutral10'), ";\n    }\n    .ui-state-secondary {\n        background: repeating-linear-gradient(-45deg, \n            ").concat(theme.selectors.color('primary20'), ", \n            ").concat(theme.selectors.color('primary20'), " 12px, \n            ").concat(theme.selectors.color('neutral0'), " 14px, \n            ").concat(theme.selectors.color('neutral0'), " 14px);\n        background-color: ").concat(theme.selectors.color('primary20'), ";\n        text-align: center;\n        &:hover {\n            background: repeating-linear-gradient(-45deg, \n                ").concat(theme.selectors.color('primary30'), ", \n                ").concat(theme.selectors.color('primary30'), " 12px, \n                ").concat(theme.selectors.color('neutral0'), " 14px, \n                ").concat(theme.selectors.color('neutral0'), " 14px);\n        }\n    }\n    .ui-state-triangle {\n        background: linear-gradient(to bottom right, ").concat(theme.selectors.color('primary70'), " 25%, transparent 25%);\n        text-align: center;\n        &:hover {\n            background: \n            linear-gradient(to bottom right, ").concat(theme.selectors.color('primary80'), " 25%, transparent 25%);\n        }\n        &.ui-state-alert {\n            background:linear-gradient(\n                -45deg, \n                transparent 0%,\n                transparent 25%, \n                ").concat(theme.selectors.color('neutral10'), " 25%,\n                ").concat(theme.selectors.color('red70'), " 25%, \n                ").concat(theme.selectors.color('red70'), " 75%, \n                ").concat(theme.selectors.color('neutral10'), " 75%,\n                transparent 75%,\n                transparent 100%);\n            text-align: center;\n            color: ").concat(theme.selectors.color('neutral0'), ";\n            &:hover {\n                background: ").concat(theme.selectors.color('red80'), "\n            }\n        }\n      \n        &.ui-state-today {\n            color: ").concat(theme.selectors.color('neutral0'), ";\n            text-align: center;\n            background-color: ").concat(theme.selectors.color('primary90'), ";\n            background: radial-gradient(circle closest-side, \n                ").concat(theme.selectors.color('primary90'), " 65%, transparent 65%);\n        }\n    }\n\n    .ui-state-tertiary {\n        position: relative;\n        &::after {\n            content: '';\n            bottom: 3px;\n            right: calc(50% - 2.5px);\n            height: 5px;\n            width: 5px;\n            background: ").concat(theme.selectors.color('neutral100'), ";\n            border-radius: 100%;\n            position: absolute;\n        }\n    }\n    .ui-state-dot {\n        position: relative;\n        &::after {\n            content: '';\n            top: 5px;\n            right: 5px;\n            height: 5px;\n            width: 5px;\n            background: ").concat(theme.selectors.color('neutral100'), ";\n            border-radius: 100%;\n            position: absolute;\n        }\n    }\n\n    .react-datepicker__day--today {\n        font-weight: normal;\n    }\n\n    .ui-state-today {\n        color: ").concat(theme.selectors.color('neutral0'), ";\n        text-align: center;\n        background-color: ").concat(theme.selectors.color('primary90'), ";\n        background: radial-gradient(circle closest-side, \n            ").concat(theme.selectors.color('primary90'), " 65%, transparent 65%);\n         &.ui-state-tertiary {\n            position: relative;\n            &::after {\n                background: ").concat(theme.selectors.color('neutral100'), ";\n            }\n        }\n        &.ui-state-dot {\n            position: relative;\n            &::after {\n                background: ").concat(theme.selectors.color('neutral100'), ";\n            }\n        }\n        &.ui-state-triangle {\n            position: relative;\n            &::after {\n                background: ").concat(theme.selectors.color('neutral100'), ";\n            }\n            background: radial-gradient(circle closest-side, \n                ").concat(theme.selectors.color('primary90'), " 65%, transparent 65%), \n            linear-gradient(\n                to bottom right, \n                ").concat(theme.selectors.color('primary70'), " 25%, \n                transparent 25%\n            );\n            text-align: center;\n            color: ").concat(theme.selectors.color('neutral0'), ";\n            &:hover {\n                background: \n                    ").concat(theme.selectors.color('red80'), ",\n                    linear-gradient(\n                        to bottom right, \n                        ").concat(theme.selectors.color('primary80'), " 25%, \n                        transparent 25%\n                    );\n            }\n            &.ui-state-alert {\n                background: radial-gradient(circle closest-side, ").concat(theme.selectors.color('primary90'), " 65%, transparent 65%), \n                linear-gradient(\n                    to bottom right, \n                    ").concat(theme.selectors.color('primary70'), " 25%, \n                    transparent 25%\n                ),\n                    linear-gradient(-45deg, \n                        ").concat(theme.selectors.color('neutral10'), " 25%, \n                        ").concat(theme.selectors.color('red70'), " 25%, \n                        ").concat(theme.selectors.color('red70'), " 75%, \n                        ").concat(theme.selectors.color('neutral10'), " 75%);\n                        &.ui-state-triangle {\n                            position: relative;\n                            &::after {\n                                background: radial-gradient(circle closest-side, ").concat(theme.selectors.color('primary90'), " 65%, transparent 65%), \n                            }\n                        }\n            }\n    \n        }\n\n        &.ui-state-secondary {\n            background: radial-gradient(circle closest-side, \n                ").concat(theme.selectors.color('primary90'), " 65%, transparent 65%), \n                repeating-linear-gradient(-45deg, \n                    ").concat(theme.selectors.color('primary20'), ", \n                    ").concat(theme.selectors.color('primary20'), " 12px, \n                    ").concat(theme.selectors.color('neutral0'), " 14px, \n                    ").concat(theme.selectors.color('neutral0'), " 14px);\n        }\n\n        &.ui-state-attention {\n            background: radial-gradient(circle closest-side, ").concat(theme.selectors.color('primary90'), " 65%, transparent 65%), \n                linear-gradient(-45deg, \n                    ").concat(theme.selectors.color('neutral10'), " 15%, \n                    ").concat(theme.selectors.color('red70'), " 15%, \n                    ").concat(theme.selectors.color('red70'), " 85%, \n                    ").concat(theme.selectors.color('neutral10'), " 85%);\n                    &.ui-state-tertiary {\n                        position: relative;\n                        &::after {\n                            background: ").concat(theme.selectors.color('neutral100'), ";\n                        }\n                    }\n        }\n        &.ui-state-alert {\n            background: radial-gradient(circle closest-side, ").concat(theme.selectors.color('primary90'), " 65%, transparent 65%), \n                linear-gradient(-45deg, \n                    ").concat(theme.selectors.color('neutral10'), " 25%, \n                    ").concat(theme.selectors.color('red70'), " 25%, \n                    ").concat(theme.selectors.color('red70'), " 75%, \n                    ").concat(theme.selectors.color('neutral10'), " 75%);\n                    &.ui-state-triangle {\n                        position: relative;\n                        &::after {\n                            background: radial-gradient(circle closest-side, ").concat(theme.selectors.color('primary90'), " 65%, transparent 65%), \n                        }\n                    }\n        }\n\n        &.ui-state-primary {\n            background: radial-gradient(circle closest-side,").concat(theme.selectors.color('primary90'), " 65%, transparent 65%),").concat(theme.selectors.color('primary70'), ";\n        }\n    }\n\n    .react-datepicker__day--outside-month {\n        color: ").concat(theme.selectors.color('neutral30'), ";\n        &.ui-state-today {\n            color: ").concat(theme.selectors.color('neutral0'), ";\n        }\n        &.ui-state-primary {\n            color: ").concat(theme.selectors.color('neutral0'), ";\n        }\n    }\n\n    .ui-state-primary {\n        background: ").concat(theme.selectors.color('primary70'), ";\n        text-align: center;\n        color: ").concat(theme.selectors.color('neutral0'), ";\n        &:hover {\n            background: ").concat(theme.selectors.color('primary80'), ";\n        }\n        &.ui-state-dot {\n            position: relative;\n            &::after {\n                background: ").concat(theme.selectors.color('neutral0'), ";\n            }\n        }\n    }\n    .ui-state-alert {\n        background:linear-gradient(\n            -45deg, \n            transparent 0%, \n            transparent 25%, \n            ").concat(theme.selectors.color('neutral10'), " 25%, \n            ").concat(theme.selectors.color('red70'), " 25%, \n            ").concat(theme.selectors.color('red70'), " 75%, \n            ").concat(theme.selectors.color('neutral10'), " 75%, \n            transparent 75%,\n            transparent 100%);\n        text-align: center;\n        color: ").concat(theme.selectors.color('neutral0'), ";\n        &:hover {\n            background: ").concat(theme.selectors.color('red80'), "\n        }\n        &.ui-state-triangle {\n            background: \n                linear-gradient(\n                    -45deg, \n                    transparent 0%,\n                    transparent 25%, \n                    ").concat(theme.selectors.color('neutral10'), " 25%,\n                    ").concat(theme.selectors.color('red70'), " 25%, \n                    ").concat(theme.selectors.color('red70'), " 75%, \n                    ").concat(theme.selectors.color('neutral10'), " 75%,\n                    transparent 75%,\n                    transparent 100% \n                ),\n            linear-gradient(\n                to bottom right, \n                ").concat(theme.selectors.color('primary70'), " 25%, \n                transparent 25%\n            );\n            text-align: center;\n            color: ").concat(theme.selectors.color('neutral0'), ";\n            &:hover {\n                background: \n                    ").concat(theme.selectors.color('red80'), ",\n                    linear-gradient(\n                        to bottom right, \n                        ").concat(theme.selectors.color('primary80'), " 25%, \n                        transparent 25%\n                    );\n            }\n        }\n        &.ui-state-dot {\n            position: relative;\n            &::after {\n                background: ").concat(theme.selectors.color('neutral0'), ";\n            }\n        }\n    }\n\n    .ui-state-attention {\n        background: linear-gradient(-45deg, \n            ").concat(theme.selectors.color('neutral10'), " 15%, \n            ").concat(theme.selectors.color('red70'), " 15%, \n            ").concat(theme.selectors.color('red70'), " 85%, \n            ").concat(theme.selectors.color('neutral10'), " 85%);\n        text-align: center;\n        color: ").concat(theme.selectors.color('neutral0'), ";\n        &:hover {\n            background: ").concat(theme.selectors.color('red80'), "\n        }\n    }\n    .react-datepicker__day--disabled {\n        color: ").concat(theme.selectors.color('neutral60'), ";\n        text-align: center;\n        background-color: white;\n        &:hover {\n            background-color: transparent;\n        }\n    }\n    .react-datepicker__day--outside-month {\n        color: ").concat(theme.selectors.color('neutral60'), ";\n        &.ui-state-attention {\n            color: ").concat(theme.selectors.color('neutral0'), ";\n        }\n    }\n\n    .react-datepicker__day-names {\n        margin-top: 3px;\n        padding-top: 24px;\n        background: white;\n        height: 54px;\n        display: flex;\n        justify-content: center;\n\n        @media (max-width: ").concat(theme.selectors.breakpoint('s').max, "px) {\n            height: 38px;\n            padding-top: 8px;\n            justify-content: center;\n        }\n    }\n\n    .react-datepicker__day-name {\n        width: calc((100vw - 32px) / 7);\n        @media (min-width: ").concat(theme.selectors.breakpoint('s').max, "px) {\n            width: 47px;\n        }\n\n        height: 48px;\n        font-size: 12px;\n        line-height: 20px;\n        font-weight: normal;\n        color: ").concat(theme.selectors.color('neutral60'), ";\n    }\n    .react-datepicker__aria-live {\n        display: none;\n    }\n\n");
});

var formatHeaderDateString = function formatHeaderDateString(date) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  if (!date) return '';
  return new Intl.DateTimeFormat(locale, {
    month: 'long',
    day: '2-digit',
    year: 'numeric'
  }).format(date);
};
var Header = function Header(_ref) {
  var startDate = _ref.startDate,
      endDate = _ref.endDate,
      navigateToNextWeek = _ref.navigateToNextWeek,
      navigateToPrevWeek = _ref.navigateToPrevWeek,
      weekStartDateRef = _ref.weekStartDateRef,
      locale = _ref.locale;
  var weekStartDate = startDate ? "".concat(startDate === null || startDate === void 0 ? void 0 : startDate.getFullYear(), "-").concat((startDate === null || startDate === void 0 ? void 0 : startDate.getMonth()) + 1, "-").concat(startDate === null || startDate === void 0 ? void 0 : startDate.getDate()) : '';
  return /*#__PURE__*/React__default["default"].createElement(layout.Row, {
    alignItems: 'center',
    justifyContent: 'space-between',
    "data-testid": WEEK_ROW_HEADER
  }, /*#__PURE__*/React__default["default"].createElement(text.Text, {
    ref: weekStartDateRef,
    "data-testId": WEEK_ROW_TITLE,
    "data-weekStartDate": weekStartDate
  }, "".concat(formatHeaderDateString(startDate, locale), " - ").concat(formatHeaderDateString(endDate, locale))), /*#__PURE__*/React__default["default"].createElement(layout.Row, {
    gridGap: 'S300'
  }, /*#__PURE__*/React__default["default"].createElement(button.Button, {
    "data-testid": WEEK_ROW_NAV_PREV,
    onClick: navigateToPrevWeek,
    icon: /*#__PURE__*/React__default["default"].createElement(icons.IconChevronLeft, {
      color: 'primary70',
      size: icons.IconSize.Small
    }),
    variant: button.ButtonVariant.Tertiary
  }), /*#__PURE__*/React__default["default"].createElement(button.Button, {
    "data-testid": WEEK_ROW_NAV_NEXT,
    onClick: navigateToNextWeek,
    icon: /*#__PURE__*/React__default["default"].createElement(icons.IconChevronRight, {
      color: 'primary70',
      size: icons.IconSize.Small
    }),
    variant: button.ButtonVariant.Tertiary
  })));
};

var validateDayElements = function validateDayElements(dayElements, emitErrorLog) {
  if (dayElements.length === 7 && findDateFromDayElement(dayElements[0]) && findDateFromDayElement(dayElements[6])) {
    return true;
  }

  if (emitErrorLog) {
    var dayEleIds = [];

    for (var i = 0; i < dayElements.length; i++) {
      var dayContent = dayElements[i].querySelector('.day-content');
      dayEleIds.push(dayContent ? dayContent.getAttribute('id') : '');
    }

    emitErrorLog("Something wrong with day elements, day element ids are ".concat(dayEleIds.join(','), ";"));
  }

  return false;
};
var findDateFromDayElement = function findDateFromDayElement(dayElement) {
  var day = dayElement === null || dayElement === void 0 ? void 0 : dayElement.querySelector('.day-content');
  var dateId = day === null || day === void 0 ? void 0 : day.getAttribute('id');
  /* TODO: This regEx is insufficient for distinguishing between valid and invalid dates. After luxon is available, consider using
   * luxon to validate the date instead. Plan to add luxon as dependency while migrate the weekly schedule into spyglass.
   * SIM: https://sim.amazon.com/issues/WSTT-579
   */

  if (!dateId || !/^date-\d{4}-\d{1,2}-\d{1,2}$/.test(dateId)) {
    return;
  }

  var _dateId$split = dateId.split('-'),
      _dateId$split2 = _rollupPluginBabelHelpers._slicedToArray(_dateId$split, 4);
      _dateId$split2[0];
      var yearStr = _dateId$split2[1],
      monthStr = _dateId$split2[2],
      dateStr = _dateId$split2[3];

  var date = new Date(Number(yearStr), Number(monthStr) - 1, Number(dateStr));
  return date;
};
var addDays = function addDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

var WeekRow = function WeekRow(_ref) {
  var selectedDate = _ref.selectedDate,
      onSelectedDateChange = _ref.onSelectedDateChange,
      weekStartDateRef = _ref.weekStartDateRef,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'en-US' : _ref$locale,
      emitErrorLog = _ref.emitErrorLog;

  var _useState = React.useState(document.querySelectorAll('.visible-week-row > .react-datepicker__day')),
      _useState2 = _rollupPluginBabelHelpers._slicedToArray(_useState, 2),
      visibleDayElements = _useState2[0],
      setVisibleDayElements = _useState2[1];

  var _useState3 = React.useState(-1),
      _useState4 = _rollupPluginBabelHelpers._slicedToArray(_useState3, 2),
      visibleRowIndex = _useState4[0],
      setVisibleRowIndex = _useState4[1];

  var _useState5 = React.useState(-1),
      _useState6 = _rollupPluginBabelHelpers._slicedToArray(_useState5, 2),
      displayingMonth = _useState6[0],
      setDisplayingMonth = _useState6[1];

  React.useEffect(function () {
    var monthContainer = document.querySelectorAll('.react-datepicker__month-container');

    if (monthContainer.length === 0 && emitErrorLog) {
      emitErrorLog('Something wrong with datepicker as the calendar is not displaying');
    }
    /*
        Upon selecting a date from a different month, we must wait for the datepicker to finish re-render
        the new month before attempting to locate the week that contains the selected date within
        the newly painted month
    */


    if (selectedDate.getMonth() !== displayingMonth) {
      return;
    }

    var targetDateId = getDateId(selectedDate);
    var weekRows = document.querySelectorAll(".react-datepicker__week");
    weekRows.forEach(function (weekRow, weekIdx) {
      var days = weekRow.querySelectorAll('.react-datepicker__day');

      for (var i = 0; i < days.length; i++) {
        var dayContent = days[i].querySelector('.day-content');

        if (dayContent.getAttribute('id') === targetDateId) {
          if (validateDayElements(days, emitErrorLog)) {
            setVisibleDayElements(days);
            setVisibleRowIndex(weekIdx);
          }

          break;
        }
      }
    });
  }, [selectedDate, displayingMonth]);
  React.useEffect(function () {
    var weekRows = document.querySelectorAll(".react-datepicker__week");
    if (visibleRowIndex < 0 || !weekRows || visibleRowIndex >= weekRows.length) return;
    weekRows[visibleRowIndex].classList.add('visible-week-row');
  }, [visibleDayElements, visibleRowIndex]);

  var navigateToNextWeek = function navigateToNextWeek() {
    var weekEndDate = findDateFromDayElement(visibleDayElements[6]);
    var newSelectedDate = addDays(weekEndDate, 1);
    onSelectedDateChange(newSelectedDate);
  };

  var navigateToPrevWeek = function navigateToPrevWeek() {
    var weekStartDate = findDateFromDayElement(visibleDayElements[0]);
    var newSelectedDate = addDays(weekStartDate, -1);
    onSelectedDateChange(newSelectedDate);
  };

  return /*#__PURE__*/React__default["default"].createElement(WeekRowWrapper, {
    "data-testid": WEEK_ROW
  }, /*#__PURE__*/React__default["default"].createElement(Header, {
    startDate: visibleDayElements && findDateFromDayElement(visibleDayElements[0]),
    endDate: visibleDayElements && findDateFromDayElement(visibleDayElements[6]),
    navigateToNextWeek: navigateToNextWeek,
    navigateToPrevWeek: navigateToPrevWeek,
    weekStartDateRef: weekStartDateRef,
    locale: locale
  }), /*#__PURE__*/React__default["default"].createElement(Datepicker, {
    inline: true,
    formatWeekDay: function formatWeekDay(day) {
      return day.substring(0, 3).toLocaleUpperCase();
    },
    selected: selectedDate,
    onChange: onSelectedDateChange,
    setDisplayingMonth: setDisplayingMonth,
    displayingMonth: displayingMonth,
    dataTestId: WEEK_ROW_DATEPICKER,
    locale: locale
  }));
};
var WeekRowWrapper = context.styledWithTheme('div')(function () {
  return " \n\n    .react-datepicker__day {\n        border: 0px !important\n    }\n\n    .datepicker-custom-header {\n        display: none\n    }\n\n    .visible-week-row {\n        display: block !important\n    }\n\n    .react-datepicker__week {\n        display: none\n    }\n";
});

exports.ATOZ_DATEPICKER = ATOZ_DATEPICKER;
exports.Datepicker = Datepicker;
exports.WEEK_ROW = WEEK_ROW;
exports.WEEK_ROW_DATEPICKER = WEEK_ROW_DATEPICKER;
exports.WEEK_ROW_HEADER = WEEK_ROW_HEADER;
exports.WEEK_ROW_NAV_NEXT = WEEK_ROW_NAV_NEXT;
exports.WEEK_ROW_NAV_PREV = WEEK_ROW_NAV_PREV;
exports.WEEK_ROW_TITLE = WEEK_ROW_TITLE;
exports.WeekRow = WeekRow;
exports.getDateId = getDateId;
//# sourceMappingURL=WeekRow-272b716e.js.map
